import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Button, Modal, Paper, Stack } from '@mui/material';
import { toast } from 'react-toastify';
import { RiDeleteBin2Line } from "react-icons/ri";

import { apiRoute, ThemeModeContext } from '../../App';
import { CaseContext } from '../../context/CaseContext';
import RestitutionModal from '../../components/modals/views/RestitutionModal';
import RestitutionView from '../../components/modals/components/restitutionTab/RestitutionView';


const Restitution = (props) => {
    const { ts,
        updateCaseBalance,
        restitutionModal,
        setRestitutionModal,
        caseNumber,
        citationNumber,
        restitutionStatuteId,
        citationView,
        caseView,
        updateBalanceRows,
        setViolationData,
        setViolationView,
        handleResetRestitutionState,
        state,
        handleFieldChange,
        paymentPlanModal,
        setPaymentPlanModal
    } = props;

    const { mode } = useContext(ThemeModeContext);
    const { restitutionCreated, setRestitutionCreated, setRestitutionState, setFeeFineRows, restitutionRows, resetRestitution, violationRows } = useContext(CaseContext);

    const [updateRestitution, setUpdateRestitution] = useState(false);
    const [updateRemitter, setUpdateRemitter] = useState(false);
    const [loading, setLoading] = useState(true);
    const [deleteRestitutionModal, setDeleteRestitutionModal] = useState(false);

    const restitutionColumns = [
        {
            field: 'paymentDate',
            headerName: 'Payment Date',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'paymentType',
            headerName: 'Payment Type',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'paymentAmount',
            headerName: 'Payment Amount',
            flex: 1,
            headerAlign: 'right',
            align: 'right',
            renderCell: (params) => {
                return (
                    <>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(params.value)}</>
                )
            },
        },
        {
            field: 'masterReceipt',
            headerName: 'Receipt #',
            flex: 1,
            headerAlign: 'right',
            align: 'right',
            width: 200
        },
        {
            field: 'enteredBy',
            headerName: 'Created By',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            width: 125
        },
    ];


    async function handleCreateRestitution() {
        setLoading(true);
        try {
            await createRestitution();
            await toast.success(`Restitution Created For Case Successfully`, {
                position: 'top-right',
                autoClose: 3500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'colored',
            });
        } catch (err) {
            console.log('Error Creating Restitution', err);
            setRestitutionCreated(false);
            setLoading(false);
            await toast.error(`Error Creating Restitution`, {
                position: 'top-right',
                autoClose: 3500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'colored',
            });
        } finally {
            setLoading(false);
        }
        return;
    }
    function handleCloseRestitutionModal() {
        setLoading(true);
        try {
            setRestitutionModal(false);
            handleResetRestitutionState()
        }
        catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
        return;
    }

    const getViolationFeeFines = (id) => {
        setFeeFineRows([]);
        if (id !== null && typeof (id) !== Array && typeof (id) === Object) {
            id = id.id;
        }
        axios.get(`${apiRoute}/api/FeeFineTbls/FkViolationId/${id}`)
            .then((res) => {
                const rows = res.data?.feeFines.map(item => ({
                    ...item,
                    id: item.pkFeeFineId,
                    collected: res.data?.collections?.filter(d => d?.fkFeeFineId === item?.pkFeeFineId)?.reduce((accumulator, collection) => accumulator += collection.disburseAmount, 0.00) ?? 0.00,
                    category: item.applyTo === 'OVERPAYMENT' ? 'OVERPAYMENT' : item.payOrderHeirarchy === 2 ? 'FINE' : item.payOrderHeirarchy === 1 ? 'COST' : 'OTHER'
                }));
                const violation = rows.findIndex(r => r.applyTo === 'ORIGINAL CHARGE');
                if (violation > -1) {
                    rows[violation].collected = rows.filter(r => r.payOrderHeirarchy === 2 && r.applyTo !== 'ORIGINAL CHARGE').reduce((accumulator, value) => accumulator += value.collected, 0.00) ?? 0.00;
                }
                setFeeFineRows(rows);
            })
            .catch((err) => {
                console.log(`error getting fine and fees for violation`, err)
            })
            .finally(() => { }
                //setLoadingFF(false)
            )
    };

    async function createRestitution() {
        const transactionViolationsRecord = {
            FkViolationId: '',
            ViolationDate: citationView.citDatetime == null ? new Date(caseView.violationDate) : citationView.citDateTime === '' ? new Date(caseView.violationDate) : citationView.citDateTime === undefined ? new Date(caseView.violationDate) : new Date(citationView.citDatetime),
            RsNumber: '',
            Description: 'RESTITUTION',
            FineAmount: '',
            CostAmount: '',
            FeeAmount: '',
            EnteredBy: '',
            DateEntered: new Date(),
        };

        const violationInfoView = {
            allowPartialPayment: '',
            amendedSpeed: '',
            amendedSpeedLimit: '',
            begDate: '1900-01-01 00:00:00.000',
            balance: '',
            comments: '',
            courtAppearRqd: '',
            currentStatute: '',
            description: 'RESTITUTION',
            chargeType: 'RESTITUTION',
            disableDelete: '',
            dispositionCode: '',
            dispositionDate: '',
            dueDate: '',
            endDate: '9999-01-01 00:00:00.000',
            entityId: '',
            fkCaseId: caseNumber,
            id: '',
            pkViolationId: '',
            remainingBalance: '',
            sentToOnlinePaymentSystem: '',
            totalCosts: '',
            totalFees: '',
            totalFines: '',
            amendmentStatus: '',
            amendmentRecordId: '',
        };
        try {
            const totalPaymentAmount = state.totalRestitutionAmount.replace(/[^0-9.]/g, '');
            const monthlyPaymentAmount = state.monthlyPaymentAmount.replace(/[^0-9.]/g, '');
            const payee = {
                PaytoName: state.remitterName,
                PaytoAddress1: state.remitterAddress1,
                PaytoAddress2: state.remitterAddress2,
                PaytoCity: state.remitterCity,
                PaytoState: state.remitterState,
                PaytoZip: state.remitterZipCode
            }
            const restitution = { 
                CaseId: caseNumber,
                TotalRestitutionAmount: parseFloat(totalPaymentAmount),
                //MonthlyPaymentAmount: parseFloat(monthlyPaymentAmount),
                //Duration: state.duration,
                StartDate: new Date(state.startDate),
                EndDate: new Date(state.endDate),
                RestitutionType: state.restitutionType
            }

            const vioRes = await axios.post(`${apiRoute}/api/violationtbls/AddViolationWithStatutes`, { pkCaseId: caseNumber, pkStatuteId: restitutionStatuteId, caseType: "RESTITUTION", pkCitId: citationNumber, fineAmount: restitution.TotalRestitutionAmount });

            await updateCaseBalance();
            await updateBalanceRows();

            restitution.ViolationId = vioRes.data.pkViolationId;
            transactionViolationsRecord.FkViolationId = vioRes.data.pkViolationId;
            getViolationFeeFines(vioRes.data.pkViolationId)
            setViolationData(vioRes.data);
            violationInfoView.currentStatute = vioRes.data.currentStatute;
            violationInfoView.id = vioRes.data.pkViolationId;
            violationInfoView.pkViolationId = vioRes.data.pkViolationId;

            const ffRes = await axios.get(`${apiRoute}/api/FeeFineTbls/ffTotals/${vioRes.data.pkViolationId}/${citationView.pkCitationId}`);

            transactionViolationsRecord.FineAmount = ffRes.data.fineTotal;
            transactionViolationsRecord.CostAmount = ffRes.data.costTotal;
            transactionViolationsRecord.FeeAmount = ffRes.data.feeTotal;

            violationInfoView.totalCosts = ffRes.data.costTotal;
            violationInfoView.totalFines = ffRes.data.fineTotal;
            violationInfoView.totalFees = ffRes.data.feeTotal;
            violationInfoView.balance = ffRes.data.costTotal + ffRes.data.fineTotal + ffRes.data.feeTotal;
            violationInfoView.remainingBalance = ffRes.data.costTotal + ffRes.data.fineTotal + ffRes.data.feeTotal;

            setViolationView(violationInfoView);

            await axios.post(`${apiRoute}/api/transactionViolationsTbls/${Number(caseNumber)}`, transactionViolationsRecord);

            const restitutionDTO = { Restitution: restitution, RestitutionPayee: payee }
            const res = await axios.post(`${apiRoute}/api/restitution/CreatePayeeAndRestitution`, restitutionDTO);

            state.duration = res.data.restitution.duration
            state.monthlyPaymentAmount = res.data.restitution.monthlyPaymentAmount

            setLoading(false);
            setRestitutionModal(false);
            setRestitutionCreated(true);

        } catch (err) {
            console.log('err: ', err);
        }
    }

    async function RetrieveRestitution(caseNumber, handleFieldChange, state) {
        const remitterProps = {
            paytoName: 'remitterName',
            paytoAddress1: 'remitterAddress1',
            paytoAddress2: 'remitterAddress2',
            paytoCity: 'remitterCity',
            paytoState: 'remitterState',
            paytoZip: 'remitterZipCode',
            payeeId: 'payeeId',
        };

        const currencyFields = ['monthlyPaymentAmount', 'totalRestitutionAmount'];

        try {
            setLoading(true);
            const res = await axios.get(`${apiRoute}/api/restitution/case/${caseNumber}`);
            for (const r in res.data.restitution) {
                if (Object.keys(state).includes(r)) {
                    handleFieldChange(
                        r, currencyFields.includes(r)
                        ?
                        new Intl.NumberFormat('en-US',
                            {
                                style: 'currency',
                                currency: 'USD',
                                maximumFractionDigits: 2
                            })
                            .format(res.data.restitution[r])
                        : r === 'startDate' || r === 'endDate'
                            ? res.data.restitution[r] === null ? "" : new Date(res.data.restitution[r]).toISOString().substring(0, 10)
                            : res.data.restitution[r]);

                    setRestitutionState((prevState) => (
                        {
                            ...prevState,
                            [r]: currencyFields.includes(r)
                                ?
                                new Intl.NumberFormat('en-US',
                                    {
                                        style: 'currency',
                                        currency: 'USD',
                                        maximumFractionDigits: 2
                                    })
                                    .format(res.data.restitution[r])
                                : res.data.restitution[r],
                        }
                    )
                    )
                }
            }

            for (const r in res.data.remitter) {
                if (Object.keys(remitterProps).includes(r)) {
                    handleFieldChange(remitterProps[r], res.data.remitter[r]);
                    setRestitutionState((prevState) => ({
                        ...prevState,
                        [remitterProps[r]]: res.data.remitter[r],
                    }))
                }
            }
            const vioView = violationRows?.filter((row) => row?.pkViolationId === res.data.restitution.violationId);
            setViolationView(vioView[0]);
            setRestitutionCreated(true);
            setLoading(false);
            return;
        } catch (err) {
            console.log('err: ', err);
            setLoading(false);
        }
        finally {
            setLoading(false)
        }
    }

    async function HandleUpdateRestitutionCards(card) {
        try {
            return (
                card === 'restitution'
                    ? await HandleUpdateRestitution()
                    : await HandleUpdateRemitter()
            );
        }
        catch (err) {
            console.log('error updating restitution')
        }
    }

    async function HandleUpdateRestitution() {
        try {
            const totalPaymentAmount = state.totalRestitutionAmount.replace(/[^0-9.]/g, '');
            const monthlyPaymentAmount = state?.monthlyPaymentAmount?.replace(/[^0-9.]/g, '') ?? null;

            const restitutionDTO = {
                CaseId: caseNumber,
                TotalRestitutionAmount: parseFloat(totalPaymentAmount),
                MonthlyPaymentAmount: parseFloat(monthlyPaymentAmount),
                Duration: state.duration,
                RestitutionType: state.restitutionType,
                StartDate: new Date(state.startDate),
                EndDate: new Date(state.endDate),
                IsActive: true,
                RestitutionFeeFineTbl: state.restitutionFeeFineTbl
            }

            await axios.put(`${apiRoute}/api/restitution/update`, restitutionDTO);

            await RetrieveRestitution(caseNumber, handleFieldChange, state);
            await updateCaseBalance();
            await updateBalanceRows();

            await toast.success(`Restitution Updated For Case Successfully`, {
                position: 'top-right',
                autoClose: 3500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'colored',
            });
        }
        catch (err) {
            await toast.error(`Failed to Update Restitution For Case`, {
                position: 'top-right',
                autoClose: 3500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'colored',
            });
            console.log('err updating restitution', err);
        } finally {
            setUpdateRestitution(false)
        }
    }

    async function HandleUpdateRemitter() {
        try {

            const payeeVM = {
                PkPayeeId: state.payeeId,
                VendorType: 'RESTITUTION',
                VendorCode: '',
                PaytoName: state.remitterName,
                PaytoAddress1: state.remitterAddress1,
                PaytoAddress2: state.remitterAddress2,
                PaytoCity: state.remitterCity,
                PaytoState: state.remitterState,
                PaytoZip: state.remitterZipCode,
                Source: '',
            }

            await axios.put(`${apiRoute}/api/payeetbls/${state.payeeId}`, payeeVM);

            await RetrieveRestitution(caseNumber, handleFieldChange, state);

            await toast.success(`Remitter Updated For Case Successfully`, {
                position: 'top-right',
                autoClose: 3500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'colored',
            });
        }
        catch (err) {
            await toast.error(`Failed to Update Remitter For Case`, {
                position: 'top-right',
                autoClose: 3500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'colored',
            });
            console.log('err updating restitution');
        } finally {
            setUpdateRemitter(false)
        }
    }

    const handleTotalRestitutionFocus = (totalRestitutionRef) => {
        handleFieldChange('totalRestitutionAmount', state.totalRestitutionAmount.replace(/[^0-9.]/g, ''));
        setTimeout(() => {
            if (totalRestitutionRef?.current) {
                totalRestitutionRef.current.setSelectionRange(0, 0); // Move cursor to start
            }
        }, 0);
    };

    const handleMonthlyPaymentFocus = (monthlyPaymentRef) => {
        handleFieldChange('monthlyPaymentAmount', state.monthlyPaymentAmount.replace(/[^0-9.]/g, ''));
        setTimeout(() => {
            if (monthlyPaymentRef?.current) {
                monthlyPaymentRef.current.setSelectionRange(0, 0); // Move cursor to start
            }
        }, 0);
    };

    async function handleDeleteRestitution() {
        try {
            await axios.delete(`${apiRoute}/api/restitution/delete/${state.id}`);
            await updateCaseBalance();
            await updateBalanceRows();
            resetRestitution();
            await toast.success(`Restitution Deleted For Case Successfully`, {
                position: 'top-right',
                autoClose: 3500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'colored',
            });
            setDeleteRestitutionModal(false);
        }
        catch (err) {
            console.log('err: ', err);
            await toast.error(`Failed to Update Restitution For Case`, {
                position: 'top-right',
                autoClose: 3500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'colored',
            });
        }
    }

    useEffect(() => {
        if (!restitutionCreated) {
            RetrieveRestitution(caseNumber, handleFieldChange, state);
        }
    }, [restitutionCreated]);

    return (
        <>
            <RestitutionView
                loading={loading}
                ts={ts}
                updateRemitter={updateRemitter}
                setUpdateRemitter={setUpdateRemitter}
                updateRestitution={updateRestitution}
                setUpdateRestitution={setUpdateRestitution}
                state={state}
                restitutionColumns={restitutionColumns}
                restitutionModal={restitutionModal}
                setRestitutionModal={setRestitutionModal}
                restitutionCreated={restitutionCreated}
                handleFieldChange={handleFieldChange}
                caseNumber={caseNumber}
                RetrieveRestitution={RetrieveRestitution}
                mode={mode}
                restitutionRows={restitutionRows}
                HandleUpdateRestitution={HandleUpdateRestitution}
                handleTotalRestitutionFocus={handleTotalRestitutionFocus}
                handleMonthlyPaymentFocus={handleMonthlyPaymentFocus}
                HandleUpdateRestitutionCards={HandleUpdateRestitutionCards}
                paymentPlanModal={paymentPlanModal}
                setPaymentPlanModal={setPaymentPlanModal}
                deleteRestitutionModal={deleteRestitutionModal}
                setDeleteRestitutionModal={setDeleteRestitutionModal}
            />

            <Modal open={restitutionModal} sx={{ width: '60vw', margin: '5vh auto' }}>
                <RestitutionModal
                    restitutionModal={restitutionModal}
                    setRestitutionModal={setRestitutionModal}
                    setRestitutionCreated={setRestitutionCreated}
                    restitutionCreated={restitutionCreated}
                    ts={ts}
                    state={state}
                    handleFieldChange={handleFieldChange}
                    handleCreateRestitution={handleCreateRestitution}
                    handleCloseRestitutionModal={handleCloseRestitutionModal}
                    loading={loading}
                    handleTotalRestitutionFocus={handleTotalRestitutionFocus}
                    handleMonthlyPaymentFocus={handleMonthlyPaymentFocus}
                />
            </Modal>
            <Modal open={deleteRestitutionModal} sx={{ width: '40vw', margin: '5vh auto' }}>
                <Box>
                    <Paper sx={{ width: 'auto', display: 'flex', height: 'auto', flexDirection: 'column', margin: 'auto', padding: 'auto', mb: '1vh' }}>
                        <Paper className="border-radius-bottom" sx={{ textAlign: 'center', backgroundColor: 'steelblue', color: 'white', p: '1vh' }} elevation={10}>
                            <h1>DELETE RESTITUTION</h1>
                        </Paper>
                        <Paper
                            sx={{
                                p: '1vh',
                                width: '98%',
                                height: '50%',
                                m: 'auto',
                                mt: '1vh',
                                backgroundColor: '#',
                                mb: '1vh'
                            }}
                            elevation={3}
                        >
                            <Stack sx={{ justifyContent: 'center', display: 'flex', alignItems: 'center' }}>
                                <h1 style={{ color: mode === 'light' ? '#ae0e0e' : 'red' }}>DANGER ZONE</h1>
                                <h4><em>are you sure you would like to delete the restitution on this case?</em></h4>
                                <h5><em>Existing Payments can still be viewed in the payments tab</em></h5>
                            </Stack>
                            <Box container sx={{ display: 'flex', justifyContent: 'center', mt: '3vh', mb: '3vh' }}>
                                <Stack
                                    direction="row"
                                    spacing={15}
                                    sx={{ p: 'auto', m: 'auto' }}
                                >
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        }}
                                    >
                                        <h4>Delete Restitution</h4>
                                        <Button
                                            onClick={async () => { await handleDeleteRestitution() }}
                                            variant="contained"
                                            sx={{
                                                backgroundColor: '#ae0e0e',
                                                opacity: '120%',
                                                color: 'white',
                                                padding: '1rem',
                                                fontSize: '1rem',
                                                width: '100%'
                                            }}
                                            startIcon={<RiDeleteBin2Line />}
                                        >
                                            Delete
                                        </Button>
                                    </Box>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        }}
                                    >
                                        <h4>Cancel</h4>
                                        <Button
                                            onClick={(e) => { setDeleteRestitutionModal(false) }}
                                            variant="contained"
                                            sx={{
                                                backgroundColor: 'steelblue',
                                                color: 'white',
                                                padding: '1rem',
                                                fontSize: '1rem',
                                                width: '123%'
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                    </Box>
                                </Stack>
                            </Box>
                        </Paper>
                    </Paper>
                </Box>
            </Modal>
        </>

    )
};

export default Restitution;